import { Alert } from '@mui/material';
import CSS from 'csstype';

interface IErrorInfo {
	sx?: CSS.Properties;
	className?: string;
	msg?: string;
}

export default function ErrorInfo({
	sx = {},
	className = "",
	msg = "",
}: IErrorInfo) {
	return <Alert color="error" severity="error" sx={sx} className={className}>
		<p>
			{ msg }
		</p>
	</Alert>;
}
